import { useDispatch } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import layout from '../../styles/layout.module.css';
import buttons from '../../styles/buttons.module.css';

const ColorPicker = ({ currentOption, options, action }) => {
    const dispatch = useDispatch();
    let option = [...options].map((elm) => {
        if (currentOption === elm.color) {
            return (
                <Button
                    className={buttons.pickerBtnContainer}
                    disableRipple={true}
                    key={elm.color}
                    onClick={() => {
                        dispatch(action(elm.color));
                    }}>
                    <img className={buttons.btnCircleActive} src={elm.icon} alt={elm.color}></img>
                </Button>
            );
        } else {
            return (
                <Button
                    disableRipple={true}
                    className={buttons.pickerBtnContainer}
                    // style={{ marginLeft: '15px', marginRight: '15px' }}
                    key={elm.color}
                    onClick={() => {
                        dispatch(action(elm.color));
                    }}>
                    <img className={buttons.btnCircle} src={elm.icon} alt={elm.color}></img>
                </Button>
            );
        }
    });
    return <Box className={layout.btnContainer}>{option}</Box>;
};

export default ColorPicker;
